import { useLayoutEffect, useCallback, useState } from 'react';

const useDynamicSize = (element) => {
  const [refHeight, setRefHeight] = useState(element?.offsetHeight);
  const [refWidth, setRefWidth] = useState(element?.offsetWidth);

  /* istanbul ignore next */
  const handleResize = useCallback((elm) => {
    setRefHeight(elm.offsetHeight);
    setRefWidth(elm.offsetWidth);
  }, []);

  useLayoutEffect(() => {
    if (!element) {
      return undefined;
    }

    /* istanbul ignore next */
    const elementSizeObserver = new ResizeObserver(([entry]) => {
      handleResize(entry.target);
    });

    elementSizeObserver.observe(element);

    return () => {
      elementSizeObserver.unobserve(element);
    };
  }, [element, handleResize]);

  return { refHeight, refWidth };
};

export default useDynamicSize;
